module.exports = __webpack_public_path__ + "assets/images/celebrity.cab30175.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Error/assets/celebrity.png
// module id = 999
// module chunks = 0